import React from 'react'
import { TabPane } from 'reactstrap'
import { SetItemsList, SequenceSetItemsList, } from '../ManageSetsComponents'

export default function SequenceSetItemsPane (props) {
  return (
    <TabPane tabId='2'>
      <SequenceSetItemsList
        items={props.items}
        sets={props.sets}
        activeSet={props.activeSet}
        handleChangeSequence={props.handleChangeSequence} 
      />
    </TabPane>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SequenceSetItemsPane.js